export default function () {
  this.loadSubscription()
}
